import script from "./pwFindComplete.vue?vue&type=script&setup=true&name=idFindDomplete&lang=js"
export * from "./pwFindComplete.vue?vue&type=script&setup=true&name=idFindDomplete&lang=js"

const __exports__ = script;

export default __exports__